import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { APP_INITIALIZER, NgModule, provideBrowserGlobalErrorListeners } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import {
  MsalGuard,
  MsalInterceptor,
  MsalModule,
  MsalRedirectComponent,
  MsalService,
  MSAL_GUARD_CONFIG,
  MSAL_INSTANCE,
  MSAL_INTERCEPTOR_CONFIG
} from '@azure/msal-angular';

import { AppRoutingModule } from './app-routing.module';
import { App } from './app';
import { EventsPageComponent } from './components/events-page.component';
import { HomePageComponent } from './components/home-page.component';
import { MyCartPageComponent } from './components/my-cart-page.component';
import { ProfilePageComponent } from './components/profile-page.component';
import { QuestionsPageComponent } from './components/questions-page.component';
import { TeamsPageComponent } from './components/teams-page.component';
import { GameEventsPageComponent } from './components/game-events-page.component';
import { JoinPageComponent } from './components/join-page.component';
import { PublicLandingPageComponent } from './components/public-landing-page.component';
import { apiBaseUrlInterceptor } from './services/api-base-url.interceptor';
import {
  msalGuardConfigFactory,
  msalInitializeFactory,
  msalInstanceFactory,
  msalInterceptorConfigFactory
} from './services/auth-config';
import { AuthRedirectComponent } from './components/auth-redirect.component';
import { LegalFooterComponent } from './components/legal-footer.component';
import { ProductsPageComponent } from './components/products-page.component';

@NgModule({
  declarations: [App],
  imports: [
    BrowserModule,
    AppRoutingModule,
    MsalModule,
    HomePageComponent,
    ProfilePageComponent,
    EventsPageComponent,
    TeamsPageComponent,
    QuestionsPageComponent,
    MyCartPageComponent,
    GameEventsPageComponent,
    JoinPageComponent,
    PublicLandingPageComponent,
    AuthRedirectComponent,
    LegalFooterComponent,
    ProductsPageComponent,
  ],
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideHttpClient(withInterceptors([apiBaseUrlInterceptor]), withInterceptorsFromDi()),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true
    },
    {
      provide: MSAL_INSTANCE,
      useFactory: msalInstanceFactory
    },
    {
      provide: APP_INITIALIZER,
      useFactory: msalInitializeFactory,
      deps: [MSAL_INSTANCE],
      multi: true
    },
    {
      provide: MSAL_GUARD_CONFIG,
      useFactory: msalGuardConfigFactory
    },
    {
      provide: MSAL_INTERCEPTOR_CONFIG,
      useFactory: msalInterceptorConfigFactory
    },
    MsalService,
    MsalGuard
  ],
  bootstrap: [App, MsalRedirectComponent]
})
export class AppModule {}
